import request from '@/assets/js/request';

/**
 * 获取用户认证信息
 * @param {} 无
 * @returns
 */
export function getUserCertification() {
    return request({
        url: '/org/view/go_user_info',
        method: 'POST',
    });
}

/**
 * 获取用户信息
 * @param {} 无
 * @returns
 */
export function getUserInfo() {
    return request({
        url: '/org/loginUserInfo',
        method: 'POST',
    });
}

/**
 * 关键字查询银行名称
 * @param {String} 查询的关键字
 * @param {String} 总行的code，如果查询总行为空
 * @returns
 */
export function queryBank(name, code = null) {
    return request.post('/letSign/queryBank', {name, code}, {formData: false});
}

/**
 * 企业升级
 * @description 选择法人/代理人
 * @param {Number} upgradeAuthType 1 法人 2 代理人
 * @returns
 */
export function enterprise(upgradeAuthType) {
    return request({
        url: '/org/upgrade/ent/start',
        method: 'POST',
        data: {upgradeAuthType},
    });
}

/**
 * 企业升级
 * @description 营业执照识别
 * @param {String} path 上传执照图片路径
 * @returns
 */
export function enterpriseLicense(path) {
    return request({
        url: '/letSign/entLicenseDiscern',
        method: 'POST',
        data: {path},
    });
}

/**
 * 企业升级
 * @description 企业信息认证
 * @param {FromData} fromData 参数请详见表单
 * @returns
 */
export function enterpriseCertify(type, fromData) {
    let url = '';
    if (type == 1) url = '/letSign/companyCorporateCert';
    if (type == 2) url = '/org/companyAgent/licenceInfo';
    if (type == 3) url = '/letSign/individualBusinessCert';
    return request.post(url, fromData, {formData: false});
}

/**
 * 企业升级
 * @description 法人短信验证码-发送
 * @param 无
 * @returns
 */
export function enterpriseSmsCode() {
    return request.get('/letSign/resendSmsCode');
}

/**
 * 企业升级
 * @description 法人短信验证码-验证
 * @param {String} smsCode 短信验证码
 * @returns
 */
export function enterpriseSmsCodeCertify(smsCode) {
    return request.post('/letSign/companyCorporate/submitSmsCode', {smsCode});
}

/**
 * 企业升级
 * @description 非法人-提交委托书模版
 * @returns
 */
export function enterpriseTemplate() {
    return request.get('/org/companyAgent/entrust/template');
}

/**
 * 企业升级
 * @description 非法人-提交委托书
 * @param {String} enTrustPhotoPath 委托书地址
 * @returns
 */
export function enterprisePowerAttorney(enTrustPhotoPath) {
    return request.post('/org/companyAgent/agentInfo', {enTrustPhotoPath});
}

/**
 * 企业升级
 * @description 非法人-对公打款信息提交
 * @param {FromData} fromData 参数请详见表单
 * @returns
 */
export function enterpriseBankConfirm(fromData) {
    return request.post('/org/companyAgent/bankInfo', fromData, {formData: false});
}

/**
 * 企业升级
 * @description 非法人-对公打款金额确认
 * @param {Number} payNumber 打款金额
 * @returns
 */
export function enterpriseBankAmountConfirm(payNumber) {
    return request.post('/org/companyAgent/bankPayInfo', {payNumber});
}

/**
 * 企业升级
 * @description 获取企业升级状态
 * @returns
 */
export function enterpriseStatus() {
    return request.post('/org/upgrade/query/status');
}

/**
 * 企业升级
 * @description 重新认证
 * @returns
 */
export function enterpriseRestart() {
    return request.post('/org/upgrade/ent/reCert');
}

/**
 * 企业合同信息- 获取
 * @returns
 */
export function getEnterpriseContract() {
    return request.post('/letSign/viewEntContract', {}, {formData: false});
}

/**
 * 企业合同信息- 验证码
 * @param {*} contractCode 合同code
 * @returns
 */
export function getEnterpriseContractSms(contractCode) {
    return request.post('/letSign/smsCodeSign', {contractCode}, {formData: false});
}

/**
 * 企业认证 - 上一步
 * @param {*} step 合同code
 * @returns
 */
export function setEnterpriseStep(step) {
    return request.post('/org/entUpgrade/backToPreviousStep', {step});
}

/**
 * 企业合同 - 签署
 * @param {*} contractCode 合同code
 * @param {*} serialNumber 验证码流水号
 * @param {*} verificationCode 验证码
 * @returns
 */
export function sendEnterpriseContract(contractCode, serialNumber, verificationCode) {
    return request.post('/letSign/entSign', {contractCode, serialNumber, verificationCode}, {formData: false});
}

/**
 * 获取企业资质信息
 * @returns
 */
export function getQualification() {
    return request.get('cpEnterpriseQualification/get', {formData: false});
}

/**
 * 移交管理员
 * @param {*} telephone 新管理员电话
 * @returns
 */
export function updateManager(telephone) {
    return request.post('org/edit/manager', {telephone});
}

/**
 * 获取状态-法大大
 * @param {*} type 1 个人认证 2 企业认证 3 修改电话号码 4 修改姓名
 * @returns 0：未提交 1：进行中 2:通过
 */
export function fddStatus(type) {
    return request.post('fabigbigfabigbig/getStatusByType', {type}, {formData: false});
}

/**
 * 企业升级-法大大
 * @description 企业信息认证
 * @param {FromData} fromData 参数请详见表单
 * @returns
 */
export function fddEnterpriseUpgrade(upgradeAuthType) {
    return request.post('/fabigbig/companyCert', {upgradeAuthType}, {formData: false});
}

/**
 * 企业升级状态-法大大
 * @description 获取企业升级状态
 * @returns
 */
export function fddEnterpriseStatus() {
    return request.post('/fabigbig/companyCertInfo');
}

/**
 * 企业签署状态-法大大
 * @returns
 */
export function fddEnterpriseContract() {
    return request.post('/fabigbig/viewEntContract', {}, {formData: false});
}

/**
 * 企业签署合同-法大大
 * @param {Number} type - 1 签署企业合同 2 签署个人升级企业合同
 * @param {Number} step - 1 管理员签署 2 法人签署
 * @returns
 */
export function fddSendEnterpriseContract(type, step) {
    switch (type) {
        case 1:
            return request.post('/fabigbig/view/entSign', {}, {formData: false});
        case 2:
            return request.post('/fabigbig/view/signOne', {step}, {formData: false});
        default:
            throw new Error('未知的签署类型');
    }
}

/**
 * 重置认证状态
 * @returns
 */
export function resetAuthenticationStatus() {
    return request.post('/fabigbig/initFabigbig', {}, {formData: false});
}
